import React, { useState } from 'react'
import PageContainerHeader from '../../molecules/PageContainerHeader/PageContainerHeader'
import AssignedProjectList from '../../molecules/AssignedProjectList/AssignedProjectList'
import ProjectDrawer from '../../molecules/ProjectDrawer/ProjectDrawer'
import { checkPermission, permissionType } from '../../../app/utils/common/Functions'
import './AssignedProjectsPage.scss'

const AssignedProjectsPage = () => {
    const [projectDrawer, setProjectDrawer] = useState(false);
    const [project, setProject] = useState();
    const editProject = (project) => {
        setProject(project);
        setProjectDrawer(true);
    }
    return (
        <div className="assigned-projects-page">
            <div className="assigned-projects-page__intro">
                <h1 className="page-title">Projects</h1>
                <p className="page-subtitle">Organize project assignments, timelines, and delivery ownership.</p>
            </div>
            <PageContainerHeader title='Assigned Projects' button={checkPermission(permissionType.PROJECT_MANAGEMENT, "create")} buttonTitle={"Add Project"} onclickDrawer={() => { setProject(null); setProjectDrawer(pre => !pre) }} />
            <AssignedProjectList editProject={(data) => editProject(data)} />
            {
                projectDrawer && <ProjectDrawer isEditOpen={projectDrawer} project={project} toggleDetailDrawer={() => setProjectDrawer(false)} isCreate={project ? false : true} />
            }
        </div>
    )
}

export default AssignedProjectsPage
